import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { ToastContainerComponent } from './core/components/toast-container.component';
import { DialogContainerComponent } from './core/components/dialog-container.component';
import { TabLockOverlayComponent } from './core/components/tab-lock-overlay.component';
import { TabLockService } from './core/services/tab-lock.service';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, DialogContainerComponent, TabLockOverlayComponent],
  template: `
    <router-outlet></router-outlet>
    <app-dialog-container></app-dialog-container>
    <app-toast-container></app-toast-container>
    <app-tab-lock-overlay></app-tab-lock-overlay>
  `,
})
export class AppComponent {
  private theme = inject(ThemeService);
  private tabLock = inject(TabLockService);
  private auth = inject(AuthService);

  constructor() {
    this.theme.init();
    // Single active tab per browser — engage while a session exists, release on sign-out.
    effect(() => {
      if (this.auth.isLoggedIn()) this.tabLock.start();
      else this.tabLock.stop();
    });
  }
}
